<template>
  <div class="roster-tab p-4">
    <template v-if="!loaded">
      <div class="text-center">
        <icon icon="loading" class="loading-icon" />
      </div>
    </template>

    <template v-else>
      <template v-if="!!event.can_view_enrollments">
        <div class="text-center">
          <a class="btn btn-primary mb-3" :href="viewRosterUrl"
            >View Full Roster</a
          >
        </div>
        <div class="details-pane-table mb-3">
          <div class="row mb-2">
            <div class="col-4 col-attribute">No. Enrolled:</div>
            <div class="col-8 col-value">{{ event.num_enrolled }}</div>
          </div>
          <div
            v-if="event.status === $root.constants.CLOSED_EVENT"
            class="row mb-2"
          >
            <div class="col-4 col-attribute">No. Attended:</div>
            <div class="col-8 col-value">{{ numAttended }}</div>
          </div>
          <div v-else class="row mb-2">
            <div class="col-4 col-attribute">Max Attendees:</div>
            <div class="col-8 col-value">{{ maxAttendees }}</div>
          </div>
          <hr />
        </div>
      </template>
      <template v-if="enrollments.length > 0">
        <template v-for="(enrollment, i) in enrollments">
          <hr v-if="i > 0" :key="`hr-${i}`" />
          <div :key="`table-${i}`" class="details-pane-table mb-3">
            <div class="row mb-2">
              <div class="col-4 col-attribute">Name:</div>
              <div class="col-8 col-value">{{ enrollment.user?.name ?? '' }}</div>
            </div>
            <div v-if="!!enrollment.user?.hvac_id" class="row mb-2">
              <div class="col-4 col-attribute">HVAC ID:</div>
              <div class="col-8 col-value">{{ enrollment.user?.hvac_id ?? '' }}</div>
            </div>
            <div v-else-if="!!enrollment.user?.is_writein" class="row mb-2">
              <div class="col-4 col-attribute">Write-In?:</div>
              <div class="col-8 col-value">Yes</div>
            </div>
            <div v-if="!!enrollment.user?.company" class="row mb-2">
              <div class="col-4 col-attribute">Company:</div>
              <div class="col-8 col-value">
                {{ enrollment.user?.company?.name ?? '' }}
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="alert alert-info">
          <span v-if="!!event.can_view_enrollments">
            There are currently no students registered for this event.
          </span>
          <span v-else>
            No one from your company is currently registered for this
            event.</span
          >
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true },
    section: { type: String, default: "registration" },
  },

  data() {
    return {
      enrollments: [],
      loaded: false,
    };
  },

  computed: {
    routeParam() {
      return { event: this.event.id };
    },
    numAttended() {
      return this.enrollments.filter((enrollment) => {
        return (
          enrollment.completion_status ===
          this.$root.constants.COMPLETION_PASSED
        );
      }).length;
    },
    maxAttendees() {
      return !!this.event.max_attendees
        ? this.event.max_attendees
        : "Unlimited";
    },
    viewRosterUrl() {
      return this.section === "admin"
        ? this.route("admin.events.enrollments.index", this.routeParam)
        : this.route("training.events.enrollments.index", this.routeParam);
    },
  },

  watch: {
    event(model) {
      this.loaded = false;
      this.load();
    },
  },

  methods: {
    load() {
      this.axios
        .get(this.route("catalog.event.roster", { event: this.event.id }))
        .then((response) => {
          this.enrollments = response.data;
          this.loaded = true;
        });
    },
  },

  mounted() {
    this.load();
  },
};
</script>